import AddIcon from '@material-ui/icons/Add';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import DeleteIcon from '@material-ui/icons/Delete';
import FontDownloadIcon from '@material-ui/icons/FontDownload';
import React, { useEffect, useState } from 'react';
import { ReduxState, useTranslate } from 'react-admin';
import { useSelector } from 'react-redux';
import UpdateMetadataAvatarTypeAndTicketingLogoDialog, {
    INCIDENT_TYPE_EDIT_FORM_NAME,
} from '../../../commons/dialog/UpdateMetadataAvatarTypeAndTicketingLogoDialog';
import MenuButtonActions, { MenuItemType } from '../../../commons/menuButtonActions';
import { CustomReducerState } from '../../../redux/reducers';
import { getIncidentTypeSelected } from '../../../redux/reducers/incidentTypes';
import {
    ROLE_CREATE_OBJECT_TYPE,
    ROLE_CREATE_OBJECT_TYPE_PROPERTIES,
    ROLE_DELETE_OBJECT_TYPE,
    ROLE_READ_GROUP_OBJECT_TYPE,
    ROLE_READ_OBJECT_TYPE_PROPERTIES,
    ROLE_UPDATE_OBJECT_TYPE,
    ROLE_UPDATE_OBJECT_TYPE_PROPERTIES,
} from '../../../utils/ROLES';
import { MetadataAvatarType } from '../../../utils/types';
import CreateIncidentTypeForm from './create';
import DeleteIncidentTypeForm from './delete';
import InstructionsDialogContainer from './instructions/instructionsContainer';

const SimpleActionMenu = () => {
    const translate = useTranslate();
    const [showCreateForm, setShowCreateForm] = useState<boolean>(false);
    const [showEditForm, setShowEditForm] = useState<boolean>(false);
    const [showDeleteForm, setShowDeleteForm] = useState<boolean>(false);
    const [showInstructionsDialog, setShowInstructionsDialog] = useState<boolean>(false);
    const [menuState, setMenuState] = useState(false);

    const selected: MetadataAvatarType | undefined = useSelector((state: CustomReducerState & ReduxState) =>
        getIncidentTypeSelected(state)
    );

    const showCreateFormFn = () => {
        setShowCreateForm(true);
    };

    const showEditFormFn = () => {
        setShowEditForm(true);
    };

    const showDeleteFormFn = () => {
        setShowDeleteForm(true);
    };

    const menuActions: MenuItemType[] = [
        {
            icon: <AddIcon />,
            text: translate('app.menuActions.create'),
            onClick: showCreateFormFn,
            disabled: false,
            roles: [
                ROLE_CREATE_OBJECT_TYPE,
                ROLE_UPDATE_OBJECT_TYPE,
                ROLE_READ_GROUP_OBJECT_TYPE,
                ROLE_READ_OBJECT_TYPE_PROPERTIES,
                ROLE_CREATE_OBJECT_TYPE_PROPERTIES,
            ],
        },
        {
            icon: <BorderColorIcon />,
            text: translate('app.menuActions.edit'),
            onClick: showEditFormFn,
            disabled: !selected,
            roles: [
                ROLE_UPDATE_OBJECT_TYPE,
                ROLE_READ_GROUP_OBJECT_TYPE,
                ROLE_READ_OBJECT_TYPE_PROPERTIES,
                ROLE_UPDATE_OBJECT_TYPE_PROPERTIES,
            ],
        },
        {
            icon: <DeleteIcon />,
            text: translate('app.menuActions.archive'),
            onClick: showDeleteFormFn,
            disabled: !selected,
            roles: [ROLE_DELETE_OBJECT_TYPE],
        },
        {
            icon: <FontDownloadIcon />,
            text: translate('app.menuActions.instructions'),
            onClick: () => setShowInstructionsDialog(true),
            disabled: !selected,
            roles: [],
        },
    ];

    const handleToggle = () => {
        setMenuState(!menuState);
    };

    return (
        <div>
            <MenuButtonActions
                buttonLabel={'app.menuActions.title'}
                overwriteButtonLabel
                menuActions={menuActions}
                menuState={menuState}
                onButtonClick={handleToggle}
            />

            {showCreateForm && <CreateIncidentTypeForm open={true} handleClose={() => setShowCreateForm(false)} />}

            {showEditForm && selected && (
                <UpdateMetadataAvatarTypeAndTicketingLogoDialog
                    open={true}
                    handleClose={() => setShowEditForm(false)}
                    selected={selected}
                    formNameToShow={INCIDENT_TYPE_EDIT_FORM_NAME}
                />
            )}

            {showDeleteForm && selected && (
                <DeleteIncidentTypeForm selected={selected} open={true} handleClose={() => setShowDeleteForm(false)} />
            )}

            {showInstructionsDialog && selected && (
                <InstructionsDialogContainer
                    subCategory={selected}
                    open={showInstructionsDialog}
                    onClose={() => setShowInstructionsDialog(false)}
                />
            )}
        </div>
    );
};

export default SimpleActionMenu;
